import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ShoppingCart, Filter } from 'lucide-react';
export function ProductsPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const products = [{
    id: 1,
    name: 'Classic Logo Tee',
    price: '$24.99',
    category: 'Apparel',
    image: 'bg-purple-100'
  }, {
    id: 2,
    name: 'Book Lover Tote',
    price: '$18.99',
    category: 'Bookish',
    image: 'bg-blue-100'
  }, {
    id: 3,
    name: 'Ocean Breeze Freshie',
    price: '$8.99',
    category: 'Freshies',
    image: 'bg-teal-100'
  }, {
    id: 4,
    name: 'School Spirit Hoodie',
    price: '$39.99',
    category: 'Fundraisers',
    image: 'bg-red-100'
  }, {
    id: 5,
    name: 'Vintage Cap',
    price: '$22.99',
    category: 'Apparel',
    image: 'bg-gray-200'
  }, {
    id: 6,
    name: 'Reader Mug',
    price: '$14.99',
    category: 'Bookish',
    image: 'bg-yellow-100'
  }, {
    id: 7,
    name: 'Vanilla Bean Freshie',
    price: '$8.99',
    category: 'Freshies',
    image: 'bg-pink-100'
  }, {
    id: 8,
    name: 'Team Support Tee',
    price: '$24.99',
    category: 'Fundraisers',
    image: 'bg-green-100'
  }];
  const filteredProducts = activeCategory === 'All' ? products : products.filter(p => p.category === activeCategory);
  const categories = ['All', 'Apparel', 'Bookish', 'Freshies', 'Fundraisers'];
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-596">
      <Header data-id="element-597" />

      <main className="flex-grow" data-id="element-598">
        <section className="bg-gray-50 py-12 border-b border-gray-200" data-id="element-599">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-600">
            <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-601">
              Shop Products
            </h1>
            <p className="text-gray-600" data-id="element-602">
              Browse our collection of pre-designed items ready to ship.
            </p>
          </div>
        </section>

        <section className="py-12" data-id="element-603">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-604">
            <div className="flex flex-col md:flex-row gap-8" data-id="element-605">
              {/* Sidebar Filters */}
              <div className="w-full md:w-64 flex-shrink-0" data-id="element-606">
                <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm sticky top-24" data-id="element-607">
                  <div className="flex items-center mb-4" data-id="element-608">
                    <Filter className="h-5 w-5 mr-2 text-purple-600" data-id="element-609" />
                    <h3 className="font-bold text-gray-900" data-id="element-610">Categories</h3>
                  </div>
                  <ul className="space-y-2" data-id="element-611">
                    {categories.map(cat => <li key={cat} data-id="element-612">
                        <button onClick={() => setActiveCategory(cat)} className={`w-full text-left px-3 py-2 rounded-md transition-colors ${activeCategory === cat ? 'bg-purple-50 text-purple-700 font-medium' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-613">
                          {cat}
                        </button>
                      </li>)}
                  </ul>
                </div>
              </div>

              {/* Product Grid */}
              <div className="flex-grow" data-id="element-614">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-615">
                  {filteredProducts.map(product => <div key={product.id} className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all overflow-hidden group" data-id="element-616">
                      <div className={`h-64 w-full ${product.image} flex items-center justify-center`} data-id="element-617">
                        <span className="text-gray-400 font-medium" data-id="element-618">
                          Product Image
                        </span>
                      </div>
                      <div className="p-6" data-id="element-619">
                        <div className="text-xs font-semibold text-purple-600 uppercase tracking-wide mb-2" data-id="element-620">
                          {product.category}
                        </div>
                        <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-621">
                          {product.name}
                        </h3>
                        <div className="flex items-center justify-between mt-4" data-id="element-622">
                          <span className="text-xl font-bold text-gray-900" data-id="element-623">
                            {product.price}
                          </span>
                          <button className="p-2 bg-gray-100 rounded-full text-gray-600 hover:bg-purple-600 hover:text-white transition-colors" data-id="element-624">
                            <ShoppingCart className="h-5 w-5" data-id="element-625" />
                          </button>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-626" />
    </div>;
}